import { getService } from 'data/function';
import { EventAction } from './EventActions';
import { EventSubprocessor } from 'modules/eventReceiver/EventSubprocessor';
// Processor defined prefix
export const PROCESSOR_PREFIX = 'ArtificialIntelligence';
// ArtificialIntelligence application event processor
export class ArtificialIntelligenceEventProcessor extends EventSubprocessor {
    static get ModelTestProcessor() {
        return getService('ModelTestProcessor');
    }
    static get AnalysisDetailsProcessor() {
        return getService('AnalysisDetailsProcessor');
    }
    static get AnalysisModalProcessor() {
        return getService('AnalysisModalProcessor');
    }
    static get FixIntentProcessor() {
        return getService('FixIntentProcessor');
    }
    static async process(payload) {
        const action = this.removeProcessorPrefix(payload.message.action, PROCESSOR_PREFIX);
        switch (action) {
            case EventAction.OpenModelTest:
                await this.ModelTestProcessor.open();
                break;
            case EventAction.DisplayAnalysisInformation:
                await this.AnalysisModalProcessor.open(payload.message.content);
                break;
            case EventAction.OpenAnalysisDetails:
                await this.AnalysisDetailsProcessor.open(payload.message.content);
                break;
            case EventAction.OpenFixIntent:
                await this.FixIntentProcessor.open(payload);
                break;
            default:
                throw `No processor available for action ${action}`;
        }
    }
}
